// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { TestableChip } from '@components/general/TestableComponents';
import { getRagMeta } from './businessViewConfig';

/**
 * A RAG status chip, coloured from the shared theme tokens via {@link getRagMeta}.
 *
 * The shared chip with a light fill and black text, led by a dot in the status colour. The
 * pill it replaced put the status colour on the label itself and failed WCAG AA.
 *
 * @param {Object} props
 * @param {string} props.status - One of 'at_risk' | 'monitor' | 'healthy' | 'unavailable'.
 * @param {string} [props.testId='rag-badge']
 * @returns {JSX.Element}
 */
const RagBadge = ({ status, testId = 'rag-badge' }) => {
  const { label, chipClass, dotClass } = getRagMeta(status);
  return (
    <TestableChip
      dataTestId={`${testId}-${status}`}
      className={`w-fit ${chipClass}`}
      value={
        <span className="flex items-center gap-1.5">
          <span className={`h-2 w-2 shrink-0 rounded-full ${dotClass}`} aria-hidden="true" />
          {label}
        </span>
      }
    />
  );
};

RagBadge.propTypes = {
  status: PropTypes.oneOf(['at_risk', 'monitor', 'healthy', 'unavailable']).isRequired,
  testId: PropTypes.string,
};

export default RagBadge;
